exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.obelometer-display[data-v-8894aa78] {\n    margin-top: 200px;\n}\n.temp-display[data-v-8894aa78] {\n    font-family: \"Consolas\", \"Bitstream Vera Sans Mono\", \"Courier New\", Courier, monospace;\n    font-weight: bolder;\n    font-size: 8em;\n    display:block;\n}\n.time-display[data-v-8894aa78] {\n    font-family: \"Consolas\", \"Bitstream Vera Sans Mono\", \"Courier New\", Courier, monospace;\n    font-weight: bolder;\n    font-size: 3em;\n    display:block;\n}\n\n", ""]);

// exports
